/*
 * @Author: stingyxin 894739825@qq.com
 * @Date: 2023-05-24 15:32:00
 * @LastEditors: stingyxin 894739825@qq.com
 * @LastEditTime: 2023-05-24 16:58:20
 * @FilePath: \testgamehall\assets\script\webSDK\facebook\FbEvent.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 数数 打点统计
 * 更多接口参照《ThinkingAnalyticsAPI》类 ,外部不能直接调用,
 * 必须通过ThinkingEvent._ta 调用
 */
import { currentChannel } from "@/config/config";
import { getDeviceId, getLinkParams, isJSON } from "./function";
import { LOCAL_STORE } from "@/config/constConfig";

export namespace FbEvent {
    /**获得fb事件 */
    function getFBEvent() {
        return (window as any).fbq;
    }

    /**获取cookie */
    function getCookieByName(name: string) {
        var r = document.cookie.match("\\b" + name + "=([^;]*)\\b");
        return r ? r[1] : "";
    }

    /**
     * 上报事件 标准事件
     * @param eventName 事件名称
     * @param agrs 事件参数 只能是json格式
     */
    function track(eventName: string, eventId: string, agrs?: any) {
        let _fbEvent = getFBEvent();
        if (!_fbEvent) {
            return;
        }
        if (agrs) {
            _fbEvent("track", eventName, agrs, { eventID: eventId });
        } else {
            // console.log("register1");
            _fbEvent("track", eventName, {}, { eventID: eventId });
        }
    }

    /**注册事件 */
    export function EventRegistr(eventId: string) {

        track('CompleteRegistration', eventId);
    }

    /**充值事件 */
    export function EventDoCharge(value: number, eventId: string) {
        let goldNum = value;
        let args = {
            value: goldNum,
            currency: currentChannel.currency,
        };
        track('Purchase', eventId, args);
    }

    /**加购事件 */
    export function EventDoInitiateCheckout(value: number, eventId: string) {
        let goldNum = value;
        let args = {
            value: goldNum,
            currency: currentChannel.currency,
        };
        track('AddToCart', eventId, args);
    }


    // 新增
    /**获取fbp 结果参考: fb.1.1596403881668.1116446470 1*/
    export function getFbp(): string {
        if (process.env.VUE_APP_ISAPP == "true") {
            let clipboardData: any = localStorage.getItem(LOCAL_STORE.CLIPBOARD_DATA);
            if (clipboardData && isJSON(clipboardData)) {
                clipboardData = JSON.parse(clipboardData);
                return clipboardData.fbp;
            }
        }
        let fbp = getCookieByName('_fbp');
        return fbp;
    }

    /**获取fbc 结果参考: fb.1.1554763741205.AbCdEfGhIjKlMnOpQrStUvWxYz1234567890 1*/
    export function getFbc(): string {
        if (process.env.VUE_APP_ISAPP == "true") {
            let clipboardData: any = localStorage.getItem(LOCAL_STORE.CLIPBOARD_DATA);
            if (clipboardData && isJSON(clipboardData)) {
                clipboardData = JSON.parse(clipboardData);
                return clipboardData.fbc;
            }
        }
        let fbc = getCookieByName('_fbc');
        if (fbc) {
            return fbc;
        }

        let _fbp = getFbp();
        if (_fbp) {
            let arr = _fbp.split('.');
            let subdomainIndex = arr[1];
            let createTime = arr[2];
            let params = getLinkParams();
            let fbclid = params.get('fbclid');
            if (fbclid) {
                fbclid = fbclid.split("#")[0];
                return `fb.${subdomainIndex}.${createTime}.${fbclid}`;
            }
        }
        return '';
    }

    /**获取客户端用户代理程序 1*/
    export function getUserAgent(): string {
        return navigator.userAgent;
    }
    /**获取客户端使用地址 1*/
    export function getEventUrl(): string {
        if (process.env.VUE_APP_ISAPP == "true") {
            let clipboardData: any = localStorage.getItem(LOCAL_STORE.CLIPBOARD_DATA);
            if (clipboardData && isJSON(clipboardData)) {
                clipboardData = JSON.parse(clipboardData);
                return clipboardData.host;
            }
            return "";
        } else {
            return window.location.href;
        }
    }
}

